import React, { useEffect, useState } from "react";
import RealTimeService from "../apiservices/RealtimeService";
import {
  Dropdown,
  Divider,
  Box,
  Button,
  Table,
  FormButton,
  FormInput,
  Form,
} from "@fluentui/react-northstar";
import { ParticipantAddIcon } from "@fluentui/react-icons-northstar";
import axios from "axios";
import "./manage-groups.css";
import { useNavigate } from "react-router-dom";
import StatsService from "../apiservices/StatsService";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

export default function ManageGroups() {
  const [showModal, setShowModal] = useState(false);
  const [buttonPressed, setButtonPressed] = useState(false);
  const [activeGroups, setActiveGroups] = useState([]);
  const [newGroupName, setNewGroupName] = useState("");
  const [groupsToActiveList, setGroupsToActiveList] = useState([]);
  const [agentsToActiveList, setAgentsToActiveList] = useState([]);
  const [agentsToActiveListData, setAgentsToActiveListData] = useState([]);
  const [queueSelected, setQueueSelected] = useState([]);
  const [agentSelected, setAgentSelected] = useState([]);

  const navigate = useNavigate();

  function handleButtonPessed() {
    setButtonPressed(true);
  }

  function getActiveGrouops(username) {
    RealTimeService.getGroups(username)
      .then((response) => {
        setActiveGroups(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  function getToken() {
    const tokenString = sessionStorage.getItem("tokenStats");
    console.log(tokenString);
    return tokenString;
  }

  function getActiveAgents() {
    RealTimeService.getAgentsList("allAgents")
      .then((response) => {
        setAgentsToActiveList(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  function getActiveAgentsData() {
    RealTimeService.getAgents("allAgents")
      .then((response) => {
        setAgentsToActiveListData(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async function getBodyToPushNewGroup() {
    const agentstoPush = [];
    for (let agent of agentSelected) {
      const foundAgent = agentsToActiveListData.find(
        (obj) => obj.name === agent
      );
      agentstoPush.push(foundAgent);
    }
    return agentstoPush;
  }

  useEffect(() => {
    const token = getToken();
    const username = sessionStorage.getItem("userName");
    const company = sessionStorage.getItem("company");
    StatsService.getActualQueues(token, username, company).then((res) =>
      setGroupsToActiveList(res.data)
    );
    getActiveGrouops(username, company);
    getActiveAgents();
    getActiveAgentsData();
  }, []);

  const getA11ySelectionMessage = {
    onAdd: (item) => setQueueSelected(item),
    onRemove: (item) => `${item} has been removed.`,
    itemsCount: (count) => {
      let narration;

      if (count === 1) {
        narration = `${count} item is selected.`;
      } else if (count >= 2) {
        narration = `${count} items are selected.`;
      }

      return narration;
    },
  };

  const getA11ySelectionAgents = {
    onAdd: (item) => setAgentSelected([...agentSelected, item]),
    onRemove: (item) => `${item} has been removed.`,
    itemsCount: (count) => {
      let narration;

      if (count === 1) {
        narration = `${count} item is selected.`;
      } else if (count >= 2) {
        narration = `${count} items are selected.`;
      }

      return narration;
    },
  };

  const onSubmit = async () => {
    const body = await getBodyToPushNewGroup();
    console.log(body);
    const username = sessionStorage.getItem("userName");

    const bodyToPost = {
      userId: username,
      groupName: newGroupName,
      queueName: queueSelected,
      agents: body,
    };
    RealTimeService.postNewGroup(bodyToPost).then((res) =>
      console.log(res.data)
    );
    confirmAlert({
      title: "Success!!",
      message: `Group ${newGroupName} has been created`,
      buttons: [
        {
          label: "OK",
          onClick: () => navigate("/realtime"),
        },
      ],
    });
  };

  return (
    <>
      <div className="realtimeBody">
        <h1 className="h1">Realtime</h1>
        <h3 className="h3">Manage Groups</h3>
        <Divider />
        <div className="manageGroupsBox">
          <div className="activeGroups">
            <div>
              Add new group{" "}
              <Button
                circular
                iconOnly
                title="Añadir un grupo nuevo"
                onClick={() => {
                  setButtonPressed(true);
                }}
              />
            </div>
            <div>
              <h4>My active groups </h4>
            </div>
            <div>
              <Box
                content="Box"
                styles={{
                  border: "1px #ccc",
                  color: "black",
                  textAlign: "Left",
                  width: "200px",
                  height: "100%",

                  // ":hover": {
                  //   color: "red",
                  // },
                }}
              >
                <Table
                  compact
                  rows={activeGroups}
                  aria-label="Compact view static table"
                />
              </Box>
            </div>
          </div>
          <div className="addGroup">
            {buttonPressed ? (
              <div>
                <div className="addGroupTittle">
                  <b> New group form</b>
                  <Divider />
                  <div className="formDiv">
                    <Form
                      onSubmit={() => {
                        onSubmit();
                      }}
                    >
                      <FormInput
                        label="Group name"
                        name="Group name"
                        id="Group name"
                        onChange={(e, v) => {
                          setNewGroupName(v.value);
                        }}
                        required
                        showSuccessIndicator={false}
                      />
                      <Dropdown
                        activeSelectedIndex
                        search
                        items={groupsToActiveList}
                        placeholder="Select a gruop"
                        getA11ySelectionMessage={getA11ySelectionMessage}
                        noResultsMessage="We couldn't find any matches."
                        a11ySelectedItemsMessage="Press Delete or Backspace to remove"
                      />
                      <Dropdown
                        activeSelectedIndex
                        search
                        multiple
                        items={agentsToActiveList}
                        placeholder="Select your agents"
                        getA11ySelectionMessage={getA11ySelectionAgents}
                        noResultsMessage="We couldn't find any matches."
                        a11ySelectedItemsMessage="Press Delete or Backspace to remove"
                      />
                      <FormButton content="Create Group" />
                    </Form>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
}
